import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { User } from 'src/app/components/users/users.model'
import { Router } from '@angular/router';
import { AuthService } from "src/app/services/auth.service";
import { TranslateService } from '@ngx-translate/core';

import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordDialogComponent } from '../dialogs/reset-password-dialog/reset-password-dialog.component';
import { SpinnerOverlayComponent } from '../dialogs/spinner-overlay/spinner-overlay.component';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {
  email: string;
  password: string;
  usersListSubs: Subscription;
  usersList: User[];
  loginForm: FormGroup;
  public selectedLanguageFlag: string = 'es';

  constructor(
    public dataService: DataService,
    public authService: AuthService,
    public firebase: AngularFireAuth,
    private formBuilder: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar
  ) { }

  login() {

    let dialogRef = this.dialog.open(SpinnerOverlayComponent, {
      panelClass: 'transparent',
      disableClose: true
    })

    this.email = this.loginForm.controls["user"].value;
    var params = { email: this.loginForm.controls["user"].value, id_token: null };
    this.authService.login(params).subscribe(data => {
      if (data.email == 'not exist') {
        this.translate.get("alerts.user_not_exist").subscribe((res: string) => {
          dialogRef.close()
          // alert(res);
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
      }
      else {
        this.firebase.signInWithEmailAndPassword(this.email, this.loginForm.controls["password"].value)
          .then((result) => {
            // Signed in
            localStorage.setItem('email', this.email);
            result.user.getIdToken()
              .then(token => {
                params = { email: this.email, id_token: token };
                this.dataService.checkUser(params).subscribe(data => {
                  if ((data.role == 'superadmin') || (data.role == 'admin')) {
                    dialogRef.close()
                    this.router.navigate(['/users']);
                  }
                  else {
                    dialogRef.close()
                    this.router.navigate(['/welcome']);
                  }
                })
              })
              .catch(error => {
                this.translate.get("alerts.incorrect_password").subscribe((res: string) => {
                  dialogRef.close()
                  // alert(res);
                  this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
                })
              })

            // ...
          })
          .catch((error) => {
            var errorCode = error.code;
            var errorMessage = error.message;
            this.translate.get("alerts.incorrect_password").subscribe((res: string) => {
              dialogRef.close()
              // alert(res);
              this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
            })
          });
      }
    });
  }


  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({ user: new FormControl('', Validators.required), password: new FormControl('', Validators.required) });
    // if (localStorage.getItem('language')) {
    //   this.selectedLanguageFlag = localStorage.getItem('language');
    // }
    // else {
    //   this.selectedLanguageFlag = 'es'
    // }
    this.selectedLanguageFlag = this.translate.currentLang
  }

  resetPassword() {
    let dialogRef = this.dialog.open(ResetPasswordDialogComponent, {
      maxWidth: '600px'
    })

  }

  logWithGoogle() {

    let dialogRef = this.dialog.open(SpinnerOverlayComponent, {
      panelClass: 'transparent',
      disableClose: true
    })


    this.authService.GoogleAuth().then(() => {

      dialogRef.close()

    })

  }
  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.selectedLanguageFlag = lang
  }

  redirectToWeb() {

    window.location.href = 'https://www.makneticfoto.com/'

  }

}
